export default __webpack_public_path__ + "static/media/WNo.1-1.95ce5f79.jpg";